import React from 'react';

const skeleton_img = 'https://p0.meituan.net/pepperfe/58b6d049d369187dfdf36749378f07e031457.png'
/**
 * 骨架屏组件
 */
const Skeleton: React.FC = () => {
  return (
    <div className="coupon-wall-skeleton">
      <img src={skeleton_img} className="coupon-wall-skeleton-img" />
    </div>
  );
};

export default Skeleton;

